/**
 * The one edit a saved widget refuses, recognised (CT-5641).
 *
 * Since the rev4 engine landed, a widget keeps the dataset it was created
 * from. Name, description, bindings and display stay editable; the dataset,
 * the columns, the entity relations and the filters do not, because the
 * generated DATASET is published and immutable and the widget's query is
 * synced against it. The backend answers `400 DSW001` and says so in words:
 *
 *   A saved widget keeps the dataset it was created from; create a new
 *   widget to use another data source
 *   …has no column for field <uuid>; create a new widget to include it
 *
 * That is a decision the author has to make — start a new widget — not a
 * failure to retry, and the generic "something went wrong, try again" toast
 * is the worst possible thing to say about it. So the message is matched
 * here, in one place, and the surfaces that save can offer the way out.
 *
 * Matched on the English sentence the backend sends, which is the only
 * marker it gives: `DSW001` is its general validation code and covers every
 * rejected parameter. If the wording is ever translated or reworded this
 * stops recognising it and the author sees the backend's own message
 * instead — worse, but not wrong, and visible.
 */

/** The phrase both variants of the rejection end with. */
const CREATE_A_NEW_WIDGET = /create a new widget/i;

/**
 * @param {Error|null|undefined} error What `useSaveWidget` caught.
 * @returns {boolean} Whether the save was refused because a saved widget's
 *   data source cannot change.
 */
export const isDataSourceLockedError = (error) =>
  CREATE_A_NEW_WIDGET.test(String(error?.message ?? ''));

export default isDataSourceLockedError;
